import { addDays, addHours, compareAsc } from "date-fns";
import { format } from "date-fns-tz";

import { POLYGON } from "constants/constants";

import { TxType } from "./types";

const TOKEN = process.env.NEXT_PUBLIC_TOKEN || "";

export const getWithdrawalData = (
  withdrawal: TxType,
  withdrawDays: number,
  isNativeChain = true
) => {
  const {
    amount,
    startTime: timestamp,
    id: index,
    isClaimable,
    isWithDrawn,
  } = withdrawal;

  let updatedDate = format(
    new Date(addDays(Number(timestamp), withdrawDays)),
    "MMM dd, yyyy hh:mm a"
  );

  if (TOKEN === POLYGON) {
    updatedDate = format(
      new Date(addHours(Number(timestamp), isNativeChain ? 50 : 10)),
      "~ MMM dd, yyyy hh:mm a"
    );
  }

  // validate toLocalDateString is supported with locale
  try {
    const dateFormat = new Date()
      .toLocaleDateString(undefined, {
        day: "2-digit",
        timeZoneName: "long",
      })
      .slice(4);

    updatedDate =
      updatedDate +
      " (" +
      dateFormat
        .split(" ")
        .map((item) => item[0])
        .join("") +
      ")";
  } catch (e) {
    updatedDate = format(
      new Date(addDays(Number(timestamp) * 1000, withdrawDays)),
      "MMM dd, yyyy hh:mm a zzz"
    );
  }

  const dueDate = new Date(
    format(
      new Date(addDays(Number(timestamp), withdrawDays)),
      "MMM dd, yyyy hh:mm a"
    )
  );

  return {
    dueDate,
    updatedDate,
    index,
    isClaimable: isWithDrawn
      ? false
      : isClaimable !== null && isClaimable !== undefined
      ? isClaimable
      : compareAsc(
          new Date(format(new Date(), "MMM dd, yyyy hh:mm a")),
          dueDate
        ) === 1,
    amount: amount,
  };
};
